import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { NavLink } from 'react-router-dom';
import ContactInfo from 'components/Components/Includes/ContactInfo';
import PropTypes from 'prop-types';

class MenuContent extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            openMenu: false,
        };
        this.toggleMeu = this.toggleMeu.bind(this);
    }

    toggleMeu()
    {
        this.setState(prevState => ({ openMenu: !prevState.openMenu }));
    }

    render()
    {
        return (
            <Menu width="100%" burgerButtonClassName={this.props.className} isOpen={this.state.openMenu} onClose={this.toggleMeu} onOpen={this.toggleMeu}>
                <div className="menu tw-h-full">
                    <div className="xl:tw-container tw-text-center tw-h-full tw-p-4">
                        <div className="tw-h-full tw-flex tw-content-center tw-flex-wrap tw-text-left tw-relative">
                            <NavLink to="/" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-block tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2" onClick={this.toggleMeu}>Home</NavLink>
                            {/* <NavLink to={'/offers'} className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-block tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2">Offers</NavLink> */}
                            <NavLink to="/faq" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2" onClick={this.toggleMeu}>FAQs</NavLink>
                            <NavLink to="/privacy-policy" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-block tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2" onClick={this.toggleMeu}>Privacy Policy</NavLink>
                            <NavLink to="/hotels" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-block tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2" onClick={this.toggleMeu}>Hotels</NavLink>
                            <NavLink to="/about-us" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2" onClick={this.toggleMeu}>About Us</NavLink>
                            <NavLink to="https://blog.luxuriavacations.com/blog" target="_blank" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2">Blog</NavLink>
                            <a href="https://app.termly.io/document/terms-of-use-for-website/ae402e0e-7649-4340-9124-24477145e7e6" target="_blank" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-block tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2" onClick={this.closeMenu}>Terms of Service</a>
                            <NavLink to="/destinations" className="font-arapey tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 hover:tw-text-orange-400 tw-block tw-w-full md:tw-w-1/2 xl:tw-w-1/3 tw-px-2" onClick={this.toggleMeu}>Destinations</NavLink>
                            <div className="tw-absolute tw-bottom-0 tw-pb-1 tw-w-full tw-hidden lg:tw-block">
                                <ContactInfo borderColor="tw-border-gray-700" />
                            </div>
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

MenuContent.propTypes = {
    className: PropTypes.string,
};

export default MenuContent;
